import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core'

import { FilterComponent } from 'src/app/shared/components/base/filter/filter.component'
import { SmartQuoteFilter } from 'src/app/shared/interfaces/smartquote/smart-quote-filter.interface'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { CalendarSelectorComponent } from 'src/app/shared/components/form-elements/calendar-selector/calendar-selector.component'
import { CustomerSearchPulloutComponent } from 'src/app/shared/components/customer/customer-search-pullout/customer-search-pullout.component'
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap'
import { InputGroupButtonComponent } from 'src/app/shared/components/form-elements/input-group-button/input-group-button.component'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { CustomerListItem } from 'src/app/shared/interfaces/customer/customer-list-item.interface'
import { CalendarRangeSelectorComponent } from 'src/app/shared/components/form-elements/calendar-range-selector/calendar-range-selector.component'

@Component({
    selector: 'sf-smartquote-search',
    imports: [ReactiveFormsModule, FilterComponent, InputGroupButtonComponent, CalendarRangeSelectorComponent],
    templateUrl: './smartquote-search.component.html',
    styleUrls: ['./smartquote-search.component.scss']
})
export class SmartquoteSearchComponent {
    private offcanvasService = inject(NgbOffcanvas)
    private destroyRef = inject(DestroyRef)
    filterForm!: FormGroup

    resetValue: SmartQuoteFilter | null = null

    @Input()
    set existingFilter(filter: SmartQuoteFilter) {
        this.filterForm?.patchValue(filter)

        this.resetValue = filter
    }

    @Output()
    onSearchClicked = new EventEmitter<SmartQuoteFilter>()

    constructor(private fb: FormBuilder) {
        this.filterForm = this.fb.group({
            customerId: this.fb.control<number | null>(null),
            dateRangeFilter: this.fb.group({
                from: this.fb.control<string | null>(''),
                to: this.fb.control<string | null>(''),
            }),
        })
    }

    search(): void {
        this.onSearchClicked.emit(this.filterForm.value as SmartQuoteFilter)
    }

    reset(): void {
        this.filterForm.reset()
        if (this.resetValue) {
            this.filterForm.patchValue(this.resetValue)
        }
        this.search()
    }

    openCustomerSearch(): void {
        const ref = this.offcanvasService.open(CustomerSearchPulloutComponent, { position: 'end' })

        ref.componentInstance.onSelectedCustomer
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((customer: CustomerListItem) => {
                this.filterForm.patchValue({ customerId: customer.id })
                ref.close()
            })
    }
}
